<template>
  <div class="asc-plot-preview">
    <asc-spinner-wrapper :loading="loading">
      <div class="asc-plot-preview--content">
        <asc-label
          value="To make edits to this plot, click the 'Edit' button."
        ></asc-label>
        <img
          class="asc-plot-preview--content-image"
          :src="imageSource"
          alt="Plot Preview Image"
        />
      </div>
    </asc-spinner-wrapper>
  </div>
</template>

<script>
import { AscPlotPreviewMixin } from '@/components/mixins'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscPlotPreview',

  components: {
    AscSpinnerWrapper,
    AscLabel,
  },

  mixins: [AscPlotPreviewMixin],
}
</script>

<style lang="scss">
.asc-plot-preview {
  overflow-x: auto;
  max-height: 600px;

  .asc-plot-preview--content-image {
    width: 100%;
    margin-top: 16px;
  }
}
</style>
